module.exports = {
  TESTER_PAGE_WIDGET: 'widget',
  TESTER_PAGE_COMPOSITION: 'composition',
  TESTER_PAGE_ARTICLE: 'article',
}
